import React from "react";
import { AlertTriangle } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";

/**
 * Staff-facing notice shown under the nav while switched into a company
 * whose membership has ended. Only CertainPath staff can ever be in this
 * state — the login gate boots the company's own users — so the copy
 * explains why the member-facing surfaces look thinned out.
 */
export default function MembershipInactiveBanner() {
  const { userAppSettings } = useSelector(
    (state: RootState) => state.userAppSettings,
  );

  if (!userAppSettings?.companyMembershipInactive) {
    return null;
  }

  return (
    <div className="flex items-center gap-2.5 border-b border-amber-300 dark:border-amber-700 bg-amber-100 dark:bg-slate-900 px-4 py-2 text-sm font-medium text-amber-900 dark:text-amber-300">
      <AlertTriangle aria-hidden="true" className="h-4 w-4 flex-shrink-0" />
      <span>
        This company doesn&apos;t have an active membership — its users
        can&apos;t sign in, and resource and event visibility is limited.
      </span>
    </div>
  );
}
